import { cellToParent } from 'h3-js'
import { type ViewState } from 'react-map-gl'
import {
	LARGE_CLUSTER_ZOOM_THRESHOLD,
	MEDIUM_CLUSTER_ZOOM_THRESHOLD,
	SMALL_CLUSTER_ZOOM_THRESHOLD,
	PLOT_ZOOM_THRESHOLD,
	LARGE_CLUSTER_RESOLUTION,
	MEDIUM_CLUSTER_RESOLUTION,
	SMALL_CLUSTER_RESOLUTION,
	LARGEST_CLUSTER_RESOLUTION,
	LARGEST_CLUSTER_ZOOM_THRESHOLD,
} from '#app/consts'
import { useStoreContext } from '#app/store'
import { ClustersLarge } from './clusters-large'
import { ClustersLargest } from './clusters-largest'
import { ClustersMedium } from './clusters-medium'
import { ClustersSmall } from './clusters-small'

export const Clusters = ({
	viewState,
}: // smallClusterOwnedPlotIds,
// mediumClusterOwnedPlotIds,
// largeClusterOwnedPlotIds,
// selectedPlotIds,
{
	viewState: ViewState
	// smallClusterOwnedPlotIds: string[]
	// mediumClusterOwnedPlotIds: string[]
	// largeClusterOwnedPlotIds: string[]
	// selectedPlotIds: string[]
}) => {
	const selectedPlotIds = useStoreContext(s => s.selectedPlotIds)
	const smallClusterOwnedPlotIds = useStoreContext(s => s.smallClusterPlotIds)
	const mediumClusterOwnedPlotIds = useStoreContext(s => s.mediumClusterPlotIds)
	const largeClusterOwnedPlotIds = useStoreContext(s => s.largeClusterPlotIds)
	const largestClusterOwnedPlotIds = useStoreContext(
		s => s.largestClusterPlotIds,
	)

	const showLargestClusters =
		viewState.zoom >= LARGEST_CLUSTER_ZOOM_THRESHOLD &&
		viewState.zoom < LARGE_CLUSTER_ZOOM_THRESHOLD

	const showLargeClusters =
		viewState.zoom >= LARGE_CLUSTER_ZOOM_THRESHOLD &&
		viewState.zoom < MEDIUM_CLUSTER_ZOOM_THRESHOLD

	const showMediumClusters =
		viewState.zoom >= MEDIUM_CLUSTER_ZOOM_THRESHOLD &&
		viewState.zoom < SMALL_CLUSTER_ZOOM_THRESHOLD

	const showSmallClusters =
		viewState.zoom >= SMALL_CLUSTER_ZOOM_THRESHOLD &&
		viewState.zoom < PLOT_ZOOM_THRESHOLD

	const selectedPlotIdsLargestClusters = selectedPlotIds.map(plot =>
		cellToParent(plot, LARGEST_CLUSTER_RESOLUTION),
	)

	const selectedPlotIdsLargeClusters = selectedPlotIds.map(plot =>
		cellToParent(plot, LARGE_CLUSTER_RESOLUTION),
	)

	const selectedPlotIdsMediumClusters = selectedPlotIds.map(plot =>
		cellToParent(plot, MEDIUM_CLUSTER_RESOLUTION),
	)

	const selectedPlotIdsSmallClusters = selectedPlotIds.map(plot =>
		cellToParent(plot, SMALL_CLUSTER_RESOLUTION),
	)

	return (
		<>
			{showSmallClusters && (
				<ClustersSmall
					ownedPlotIds={smallClusterOwnedPlotIds}
					selectedPlotIds={selectedPlotIdsSmallClusters}
				/>
			)}
			{showMediumClusters && (
				<ClustersMedium
					ownedPlotIds={mediumClusterOwnedPlotIds}
					selectedPlotIds={selectedPlotIdsMediumClusters}
				/>
			)}
			{showLargeClusters && (
				<ClustersLarge
					ownedPlotIds={largeClusterOwnedPlotIds}
					selectedPlotIds={selectedPlotIdsLargeClusters}
				/>
			)}
			{showLargestClusters && (
				<ClustersLargest
					ownedPlotIds={largestClusterOwnedPlotIds}
					selectedPlotIds={selectedPlotIdsLargestClusters}
				/>
			)}
		</>
	)
}
